import {str} from 'shared/utils/str';

type KeysMap<TPayload> = Partial<Record<keyof TPayload, string>>;

export function overrideKeys<TPayload>(
  overrides: KeysMap<TPayload> = {}
): ParametersConverter<TPayload> {
  return function converter(payload: TPayload) {
    const result: ThirdPartyParameters = {};

    Object.entries(payload).forEach(([key, value]) => {
      const overridden = overrides[key as keyof TPayload] || key;
      result[overridden] = str(value);
    });

    return result;
  };
}

export const withoutOverrides = overrideKeys({});
